<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <!-- Web Refunds Configuration Section -->
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{ "salesforcexml.web_returns_configuration" | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content style="padding: 10px;">
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="100" fxFlex.gt-sm="100">
                <mat-label style="text-align: left;"
                  >{{ "salesforcexml.disallow_web_return_type" | translate }}</mat-label
                >
                <mat-form-field id="matFrmFieldDisallowWebReturnType" style="padding-left: 60pt;">
                  <mat-label>Please Select</mat-label>
                  <mat-select
                    id="selectDisallowWebReturnType"
                    formControlName="disallowWebReturnType"
                  >
                    <!-- todo (selectionChange)="onDisallowWebReturnTypeChange($event)" -->
                    <mat-option value="ONLINEWEBORDER">
                      {{ "salesforcexml.online_web_order" | translate }}
                    </mat-option>
                    <mat-option value="INSTOREWEBORDER">
                      {{ "salesforcexml.instore_web_order" | translate }}
                    </mat-option>
                  </mat-select>
                  <!-- <mat-error *ngIf="exportProviderControl.hasError('required')"
                          >Please Select Any One</mat-error
                        > -->
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title>{{ "salesforcexml.ftp_configuration" | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content style="text-align: center; padding: 40px;">
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-padding-bottom-20">
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpUrl" class="mat-block">
                  <input
                    id="txtuserFtpUrl"
                    matInput
                    [placeholder]="'salesforcexml.ftp_url' | translate"
                    formControlName="userFtpUrl"
                    [required]="isRequired('userFtpUrl')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpUserName" class="mat-block">
                  <input
                    id="txtuserFtpUserName"
                    matInput
                    [placeholder]="'salesforcexml.ftp_username' | translate"
                    formControlName="userFtpUserName"
                    [required]="isRequired('userFtpUserName')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpPassword" class="mat-block">
                  <input
                    id="txtuserFtpPassword"
                    matInput
                    type="password"
                    [placeholder]="'salesforcexml.ftp_password' | translate"
                    formControlName="userFtpPassword"
                    [required]="isRequired('userFtpPassword')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpFolderName" class="mat-block">
                  <input
                    id="txtuserFtpFolderName"
                    matInput
                    type="text"
                    [placeholder]="'salesforcexml.ftp_path' | translate"
                    formControlName="ftpPath"
                    [required]="isRequired('ftpPath')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpPort" class="mat-block">
                  <input
                    id="txtuserFtpPort"
                    matInput
                    type="text"
                    [placeholder]="'salesforcexml.ftp_port' | translate"
                    formControlName="userFtpPort"
                    [required]="isRequired('userFtpPort')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <div
                  fxLayout="row wrap"
                  class="u-margin-top-10 u-margin-bottom-10"
                  fxLayoutGap="20px grid"
                >
                  <mat-checkbox
                    id="matCheckboxsftp{{authControlKey}}"
                    formControlName="sftp"
                    placeholder="SFTP"
                    >SFTP
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{ "salesforcexml.authentication_details" | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content style="text-align: center; padding: 40px;">
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-padding-bottom-20">
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldSalesForcexmlUrl" class="mat-block">
                  <input
                    id="txtSalesForcexmlUrl"
                    matInput
                    [placeholder]="'salesforcexml.url' | translate"
                    formControlName="url"
                    [required]="isRequired('url')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldSalesForcexmlClientId" class="mat-block">
                  <input
                    id="txtSalesForcexmlClientId"
                    matInput
                    [placeholder]="'salesforcexml.client_id' | translate"
                    formControlName="clientId"
                    [required]="isRequired('clientId')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldSalesForcexmlSecretKey" class="mat-block">
                  <input
                    id="txtSalesForcexmlSecretKey"
                    matInput
                    type="password"
                    [placeholder]="'salesforcexml.secret_key' | translate"
                    formControlName="secretKey"
                    [required]="isRequired('secretKey')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldSalesForcexmlGrantType" class="mat-block">
                  <input
                    id="txtSalesForcexmlGrantType"
                    matInput
                    type="text"
                    [placeholder]="'salesforcexml.grant_type' | translate"
                    formControlName="grantType"
                    [required]="isRequired('grantType')"
                  />
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="100">
                <mat-card class="u-margin-bottom-15">
                  <mat-card-header>
                    <div fxFlex="20" class="u-text-left">
                      <mat-card-title>{{ "salesforcexml.api_details" | translate }}</mat-card-title>
                    </div>
                    <div fxFlex="80" class="u-text-right">
                      <button
                        [disabled]="action=='view' || isWebReturnsSalesforcexmlAddDisabled "
                        mat-flat-button
                        color="primary"
                        (click)="openSalesforcexmlSelectApiPopup();"
                      >
                        {{ 'salesforcexml.add' | translate}}
                      </button>
                    </div>
                  </mat-card-header>
                  <mat-card-content
                    *ngFor="let apiDetails of parentForm.get(authControlKey).get('salesforcexmlApiDetails')['controls']; let i = index"
                    formArrayName="salesforcexmlApiDetails"
                  >
                    <div [formGroupName]="i">
                      <div fxFlex="80">
                        <mat-accordion>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                {{ apiDetails.value.selectedApi}}
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div fxLayout="row wrap" fxLayoutGap="20px grid">
                              <div fxFlex="50">
                                <mat-form-field class="mat-block">
                                  <input
                                    id="ebasketURL"
                                    [required]="isRequired('url')"
                                    formControlName="url"
                                    matInput
                                    [placeholder]="
                            'salesforcexml.url' |
                            translate"
                                  />
                                </mat-form-field>
                              </div>
                              <div fxFlex="50">
                                <mat-form-field class="mat-block">
                                  <mat-select
                                    id="ebasketMethod"
                                    [required]="isRequired('method')"
                                    formControlName="method"
                                    [placeholder]="
                              'salesforcexml.select_method' |
                              translate"
                                  >
                                    <mat-option
                                      *ngFor="let methods of method_types"
                                      [value]="methods.value"
                                    >
                                      {{methods.name}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                      <div fxFlex="20" class="u-text-right">
                        <button
                          [disabled]="action=='view'"
                          mat-flat-button
                          color="primary"
                          (click)="deleteSalesforcexmlApiDetailContainer(i);"
                        >
                          {{ 'salesforcexml.delete' | translate}}
                        </button>
                      </div>
                    </div>
                  </mat-card-content>
                  <div
                    *ngFor="let apiDetails of parentForm.get(authControlKey).get('salesforcexmlApiDetails')['controls']; let i = index"
                  >
                    <mat-error
                      *ngIf="(action !== 'view') && (!apiDetails.value.url || !apiDetails.value.method)"
                    >
                      {{"salesforceosu.api_and_authentication_details_required" | translate }}
                    </mat-error>
                  </div>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
